module.exports = __webpack_public_path__ + "static/media/hubpic9.9d176c63.jpg";